/**
 * @generated SignedSource<<4e6786efe38b7332efa4c7c502f3a050>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type courseSectionsPreview_section$data = {
  readonly classes: ReadonlyArray<{
    readonly completed: boolean;
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"courseSectionsPreview_lesson">;
  }>;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "courseSectionsPreview_section";
};
export type courseSectionsPreview_section$key = {
  readonly " $data"?: courseSectionsPreview_section$data;
  readonly " $fragmentSpreads": FragmentRefs<"courseSectionsPreview_section">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "courseSectionsPreview_section",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "ACTIVE"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "classes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completed",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "courseSectionsPreview_lesson"
        }
      ],
      "storageKey": "classes(status:\"ACTIVE\")"
    }
  ],
  "type": "CourseSection",
  "abstractKey": null
};
})();

(node as any).hash = "a0dd0c1db75a88083e2c64606de4b0f8";

export default node;
